package com.essntl.uikit.components.datepicker

import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun EsDatePickerDialog(
    onDismissRequest: () -> Unit,
    confirmButton:  @Composable () -> Unit,
    dismissButton:  @Composable () -> Unit,
    colors: DatePickerColors = DatePickerDefaults.colors(),
    state: DatePickerState,
    modifier: Modifier = Modifier,
) {
    DatePickerDialog(
        onDismissRequest = onDismissRequest,
        confirmButton = confirmButton,
        dismissButton = dismissButton,
        colors = colors,
    ) {
        DatePicker(
            state = state,
            showModeToggle = false,
            title = null,
            colors = colors,
            modifier = modifier,
        )
    }
}